













































































































































import Vue from 'vue';
import EnemyTooltip from '@/components/enemy/EnemyTooltip.vue';
import EnemyMaster from '@/classes/enemy/enemyMaster';
import Const from '@/classes/const';
import Enemy from '@/classes/enemy/enemy';

export default Vue.extend({
  name: 'EnemyList',
  components: {
    EnemyTooltip,
  },
  props: {
    handleDecideEnemy: {
      type: Function,
      required: true,
    },
    handleClose: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    all: [] as EnemyMaster[],
    enemies: [] as EnemyMaster[],
    types: [] as { text: string; types: number[] }[],
    type: 0,
    isLandBase: false,
    keyword: '',
    enabledTooltip: false,
    tooltipTimer: undefined as undefined | number,
    tooltipEnemy: new Enemy(),
    tooltipX: 0,
    tooltipY: 0,
  }),
  mounted() {
    const existTypes: number[] = [];
    const enemies = this.$store.state.defaultEnemies as EnemyMaster[];
    for (let i = 0; i < enemies.length; i += 1) {
      const enemy = enemies[i];
      this.all.push(enemy);
      if (!existTypes.includes(enemy.type)) {
        existTypes.push(enemy.type);
      }
    }
    for (let i = 0; i < Const.SHIP_TYPES_ALT.length; i += 1) {
      const data = Const.SHIP_TYPES_ALT[i];
      if (data.types.some((v) => existTypes.includes(v))) {
        this.types.push({ text: data.text, types: data.types });
      }
    }
    this.filter();
  },
  methods: {
    changeType(index = 0) {
      this.type = index;
      this.filter();
    },
    filter() {
      const word = this.keyword;
      let result = this.all.concat();
      const t = this.types[this.type];

      // 検索語句あればこれ以外の検索はしない
      if (word) {
        result = result.filter((v) => v.id === +word || v.name.indexOf(word) >= 0);
      } else if (this.isLandBase) {
        // 地上施設ONLY
        result = result.filter((v) => v.isLandBase);
      } else if (t) {
        // カテゴリ検索
        result = result.filter((v) => !v.isLandBase && t.types.includes(v.type));
      }

      this.enemies = result;
    },
    clickedEnemy(enemy: EnemyMaster) {
      this.clearTooltip();
      this.handleDecideEnemy(enemy);
    },
    close() {
      this.handleClose();
    },
    bootTooltip(enemy: EnemyMaster, e: MouseEvent) {
      if (!enemy.id) {
        return;
      }
      const nameDiv = (e.target as HTMLDivElement).getElementsByClassName('enemy-id')[0] as HTMLDivElement;
      this.tooltipTimer = window.setTimeout(() => {
        const rect = nameDiv.getBoundingClientRect();
        this.tooltipX = e.clientX;
        this.tooltipY = rect.y + rect.height;
        const manualEnemies = this.$store.state.manualEnemies as EnemyMaster[];
        const manualEnemy = manualEnemies.find((v) => v.id === enemy.id);
        if (manualEnemy) {
          this.tooltipEnemy = Enemy.createEnemyFromMaster(manualEnemy, false, this.$store.state.items);
        } else {
          this.tooltipEnemy = Enemy.createEnemyFromMaster(enemy, false, this.$store.state.items);
        }
        this.enabledTooltip = true;
      }, 400);
    },
    clearTooltip() {
      this.enabledTooltip = false;
      window.clearTimeout(this.tooltipTimer);
    },
  },
});
